import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Contact from 'src/app/model/Contact/contact';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class AppointmentContactChoicesControllerRequestService {
  private static BASE_URL = '/contacts';
  private readonly post: <T>(
    path: string,
    body: number[],
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as Contact[];

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };

    this.post = _post(
      AppointmentContactChoicesControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getAppointmentContactChoices(
    companyIds: number[]
  ): Promise<Contact[]> {
    return this.post(
      '/appointmentContactChoices',
      companyIds,
      this.deserialize
    ).toPromise();
  }
}
